import * as React from 'react';
import {
    FormGroup,
    FormControl,
    ControlLabel,
    Checkbox,
    HelpBlock,
    Col,
    Row,
    Modal,
    Button
} from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import { IComment } from '../Entities';

interface MultipleReturnsCommentModal {
    shouldShowModal: boolean;
    onClose: () => void;
    onChange: (e: any) => void;
    onReturnImages: () => void;
    errors: any;
    comment: IComment;
}

const MultipleReturnsCommentModal = (props: MultipleReturnsCommentModal) => {
    return (
        <div>
            <Modal show={props.shouldShowModal} onHide={props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Translate('multiple-returns-comment/modal/header/comment')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <fieldset>
                        <legend className="required">
                            {Translate('multiple-returns-comment/modal/legend-label/comment')}
                        </legend>

                        <FormGroup className="required">
                            <ControlLabel>
                                {Translate(
                                    'multiple-returns-comment/modal/textarea-label/write-comment'
                                )}
                            </ControlLabel>
                            <FormControl
                                onChange={props.onChange}
                                name="comment.text"
                                componentClass="textarea"
                            />
                            {props.errors.text && <HelpBlock>{props.errors.text}</HelpBlock>}
                        </FormGroup>

                        <FormGroup className="required">
                            <ControlLabel>
                                {Translate(
                                    'multiple-returns-comment/modal/input-label/choose-recipient'
                                )}
                            </ControlLabel>
                        </FormGroup>
                        <Row>
                            <Col xs={2}>
                                <FormGroup>
                                    <Checkbox
                                        inline
                                        name="comment.toPhotographer"
                                        onChange={props.onChange}
                                    >
                                        <span>
                                            {Translate(
                                                'multiple-returns-comment/modal/input-label/to-photographer'
                                            )}
                                        </span>
                                    </Checkbox>
                                </FormGroup>
                            </Col>

                            <Col xs={2}>
                                <FormGroup>
                                    <Checkbox
                                        inline
                                        name="comment.toImageEditor"
                                        onChange={props.onChange}
                                    >
                                        <span>
                                            {Translate(
                                                'multiple-returns-comment/modal/input-label/to-imageeditor'
                                            )}
                                        </span>
                                    </Checkbox>
                                </FormGroup>
                            </Col>

                            <Col xs={2}>
                                <FormGroup>
                                    <Checkbox
                                        inline
                                        name="comment.toSe360"
                                        onChange={props.onChange}
                                    >
                                        <span>
                                            {Translate(
                                                'multiple-returns-comment/modal/input-label/to-se360'
                                            )}
                                        </span>
                                    </Checkbox>
                                </FormGroup>
                            </Col>
                            {props.errors.recipients && (
                                <HelpBlock>{props.errors.recipients}</HelpBlock>
                            )}
                        </Row>
                    </fieldset>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.onClose}>
                        {Translate('multiple-returns-comment/modal/button-label/close')}
                    </Button>
                    <Button
                        onClick={props.onReturnImages}
                        bsStyle="primary"
                        disabled={canSendComment(props.comment)}
                    >
                        {Translate('multiple-returns-comment/modal/button-label/send')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

function canSendComment(comment: IComment) {
    return (
        !(comment.toImageEditor || comment.toPhotographer || comment.toSe360) &&
        !(comment.text.length === 0)
    );
}

export default MultipleReturnsCommentModal;
